<template>
    <div class="formItem formCheckbox" :class="{'formError' : error}">
        <input v-if="typeof inputValue !== 'undefined'"
               type="checkbox"
               :id="id"
               :checked="isChecked"
               :disabled="disabled"
               :value="inputValue"
               @change="valueChanged"/>
        <input v-else :disabled="disabled" type="checkbox" :id="id" :checked="value" @input="valueChanged"/>
        <slot name="label" :id="id" :label="label" :disabled="disabled" :data="data">
            <label :for="id">
                <i></i>
                <span>{{ label }}</span>
            </label>
        </slot>
    </div>
</template>

<script>
  export default {
    props: {
      disabled: Boolean,
      label: {
        type: String
      },
      value: {
        type: [String, Boolean, Number, Array],
        default: false
      },
      inputValue: {
        type: [String, Boolean, Number],
        default: undefined
      },
      error: Boolean,
      data: Object
    },
    data () {
      return {
        id: this._uid
      }
    },
    methods: {
      valueChanged (e) {
        let result = e.target.checked ? typeof this.inputValue !== 'undefined' ? this.inputValue : e.target.checked : false
        if (typeof this.inputValue !== 'undefined' && result === this.value) {
          e.target.checked = true
          return
        }

        if (this.localValue instanceof Array) {
          if (result === false) {
            this.localValue.splice(this.localValue.indexOf(this.inputValue), 1)
            this.$emit('input', this.localValue)
          } else {
            this.localValue.push(result)
            this.$emit('input', this.localValue)
          }
        } else {
          this.localValue = result
          e.target.checked = this.localValue
        }
      }
    },
    computed: {
      localValue: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      },
      isChecked () {
        if (this.localValue instanceof Array) {
          return this.localValue.indexOf(this.inputValue) !== -1
        }
        return this.localValue == this.inputValue
      }
    }
  }
</script>

<style scoped>

</style>
